'use client';

/**
 * SysObeyaExplorerHighCcFunctionsCard — explorer report-picker for
 * `sel:high_cc_functions`.
 *
 * Click row → dispatches `setExplorerSelection('high_cc_functions')`.
 * Click kebab → opens the per-report menu (Copy report / Download
 * capture). Capture bundles every observed BFF payload + the
 * rendered scene mirror — one file, two artifacts.
 *
 * Important: this card calls `useSystemObeyaView(high_cc_functions)`
 * so it (a) gets the labels for chrome, (b) shares the React Query
 * cache entry with the canvas cards once the selection is active.
 * That same shared query is what the capture envelope picks up.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_explorer_high_cc_functions"
 * @see klyde_edge/ui_config/labels/system_obeya.py — sel_high_cc_functions_*, action_download_capture
 */

import { Cpu } from 'lucide-react';
import { useSystemObeyaView } from '@/components/canvas/cards/system_obeya/use-system-obeya-view';
import { ReportTile } from './report-tile';

const VIEW_NAME = 'high_cc_functions';

export function SysObeyaExplorerHighCcFunctionsCard() {
  const { data } = useSystemObeyaView(VIEW_NAME);
  const L = data?.labels ?? {};

  return (
    <ReportTile
      selection={VIEW_NAME}
      label={L.sel_high_cc_functions_label ?? ''}
      description={L.sel_high_cc_functions_description}
      Icon={Cpu}
      copyReportLabel={L.action_copy_report}
      downloadCaptureLabel={L.action_download_capture}
      menuLabel={L.report_menu_label}
      mode="mode9"
      contentKey="sys_obeya_explorer_high_cc_functions"
    />
  );
}
